(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = geocode

function geocode (address, callback) {
  doGeocode(address, function (response) {
    handleResponse(response, address, callback)
  })
}

function handleResponse (response, address, callback) {
  if (response && response.status === 'OK') {
    callback(response)
  } else if (response && response.status === 'OVER_QUERY_LIMIT') {
    setTimeout(function () {
      doGeocode(address, function (response) {
        handleResponse(response, address, callback)
      })
    }, 250)
  } else {
    callback()
  }
}

function doGeocode (address, callback) {
  if (!address || !address.length) return callback()
  Backbone.ajax(
    { url: window.config.apiUrl + '/map/get-address-location/' + encodeURIComponent(address)
    , contentType: 'application/json'
    , type: 'GET'
    , success: function (response) {
        callback(response)
      }
    , error: function () {
        callback()
      }
    }
  )
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/admin/tour/lib/geocode.js","/components/admin/tour/lib")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbXBvbmVudHMvYWRtaW4vdG91ci9saWIvZ2VvY29kZS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQSIsImZpbGUiOiJnZW5lcmF0ZWQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlc0NvbnRlbnQiOlsibW9kdWxlLmV4cG9ydHMgPSBnZW9jb2RlXG5cbmZ1bmN0aW9uIGdlb2NvZGUgKGFkZHJlc3MsIGNhbGxiYWNrKSB7XG4gIGRvR2VvY29kZShhZGRyZXNzLCBmdW5jdGlvbiAocmVzcG9uc2UpIHtcbiAgICBoYW5kbGVSZXNwb25zZShyZXNwb25zZSwgYWRkcmVzcywgY2FsbGJhY2spXG4gIH0pXG59XG5cbmZ1bmN0aW9uIGhhbmRsZVJlc3BvbnNlIChyZXNwb25zZSwgYWRkcmVzcywgY2FsbGJhY2spIHtcbiAgaWYgKHJlc3BvbnNlICYmIHJlc3BvbnNlLnN0YXR1cyA9PT0gJ09LJykge1xuICAgIGNhbGxiYWNrKHJlc3BvbnNlKVxuICB9IGVsc2UgaWYgKHJlc3BvbnNlICYmIHJlc3BvbnNlLnN0YXR1cyA9PT0gJ09WRVJfUVVFUllfTElNSVQnKSB7XG4gICAgc2V0VGltZW91dChmdW5jdGlvbiAoKSB7XG4gICAgICBkb0dlb2NvZGUoYWRkcmVzcywgZnVuY3Rpb24gKHJlc3BvbnNlKSB7XG4gICAgICAgIGhhbmRsZVJlc3BvbnNlKHJlc3BvbnNlLCBhZGRyZXNzLCBjYWxsYmFjaylcbiAgICAgIH0pXG4gICAgfSwgMjUwKVxuICB9IGVsc2Uge1xuICAgIGNhbGxiYWNrKClcbiAgfVxufVxuXG5mdW5jdGlvbiBkb0dlb2NvZGUgKGFkZHJlc3MsIGNhbGxiYWNrKSB7XG4gIGlmICghYWRkcmVzcyB8fCAhYWRkcmVzcy5sZW5ndGgpIHJldHVybiBjYWxsYmFjaygpXG4gIEJhY2tib25lLmFqYXgoXG4gICAgeyB1cmw6IHdpbmRvdy5jb25maWcuYXBpVXJsICsgJy9tYXAvZ2V0LWFkZHJlc3MtbG9jYXRpb24vJyArIGVuY29kZVVSSUNvbXBvbmVudChhZGRyZXNzKVxuICAgICwgY29udGVudFR5cGU6ICdhcHBsaWNhdGlvbi9qc29uJ1xuICAgICwgdHlwZTogJ0dFVCdcbiAgICAsIHN1Y2Nlc3M6IGZ1bmN0aW9uIChyZXNwb25zZSkge1xuICAgICAgICBjYWxsYmFjayhyZXNwb25zZSlcbiAgICAgIH1cbiAgICAsIGVycm9yOiBmdW5jdGlvbiAoKSB7XG4gICAgICAgIGNhbGxiYWNrKClcbiAgICAgIH1cbiAgICB9XG4gIClcbn1cbiJdfQ==